<template>
    <div>Logout</div>
</template>

<script>

//import router from '../router/index';
//import { AUTH_LOGOUT } from '../store/actions/authentication';


export default {	
    name: "Logout",

    components: {},
    
    methods:{},
    
	mounted(){
        /*this.$store.dispatch(AUTH_LOGOUT)
            .then(() => {
                router.go("/");
        });*/
	}
};

</script>